import { render, staticRenderFns } from "./ViewMethodReplicantResults.vue?vue&type=template&id=f56344ba&scoped=true"
import script from "./ViewMethodReplicantResults.vue?vue&type=script&lang=js"
export * from "./ViewMethodReplicantResults.vue?vue&type=script&lang=js"
import style0 from "./ViewMethodReplicantResults.vue?vue&type=style&index=0&id=f56344ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56344ba",
  null
  
)

export default component.exports